import React, { useEffect, useContext } from 'react';
import { AuthContext } from '@/App';

const TawkChat = () => {
  const { user } = useContext(AuthContext);

  useEffect(() => {
    // Wait for Tawk_API to be fully loaded
    const initializeTawk = () => {
      try {
        if (user && window.Tawk_API && window.Tawk_API.onLoad) {
          // Set user attributes for personalized chat experience
          window.Tawk_API.onLoad = function() {
            try {
              if (window.Tawk_API && window.Tawk_API.setAttributes) {
                window.Tawk_API.setAttributes({
                  'name': user.name || user.email,
                  'email': user.email,
                  'user_id': user.id,
                  'account_type': user.is_admin ? 'Admin' : 'Customer'
                }, function(error) {
                  if (error) {
                    console.warn('Tawk.to attributes error:', error);
                  }
                });
              }
            } catch (error) {
              console.warn('Tawk.to initialization error:', error);
            }
          };
        }
      } catch (error) {
        console.warn('Tawk.to setup error:', error);
      }
    };

    // Try to initialize immediately
    initializeTawk();

    // Also set up a delayed initialization in case Tawk loads late
    const timeoutId = setTimeout(initializeTawk, 2000);

    return () => clearTimeout(timeoutId);
  }, [user]);

  return null; // This component doesn't render anything visible
};

// Utility functions to control Tawk.to widget
export const openChat = () => {
  if (window.Tawk_API) {
    window.Tawk_API.maximize();
  }
};

export const toggleChat = () => {
  if (window.Tawk_API) {
    window.Tawk_API.toggle();
  }
};

export const hideChat = () => {
  if (window.Tawk_API) {
    window.Tawk_API.hideWidget();
  }
};

export const showChat = () => {
  if (window.Tawk_API) {
    window.Tawk_API.showWidget();
  }
};

export default TawkChat;